//import { setInterval } from "timers";

export class Slider {

    public InitSlider($sliderContainer, intervalInSeconds: number, animationInSeconds: number) {
        const $carusselSlider = $sliderContainer.find('.carussel-slider');
        let $sliderItems = $carusselSlider.find('.carussel-slider-item');

        if (intervalInSeconds < 1) {
            intervalInSeconds = 1;
        }

        if (animationInSeconds < 1) {
            animationInSeconds = 1;
        }

        var i = 0;

        if ($sliderItems.length > 1) {
            const intervall = setInterval(() => {
                /* css-Klasse für Animation hinzufügen*/
                $carusselSlider.css('transition', `left ${animationInSeconds}s ease-in-out`); 
                /* left setzen*/
                $carusselSlider.css('left', '-100%');

                setTimeout(() => {
                    console.log(i++);
                    $sliderItems = $carusselSlider.find('.carussel-slider-item');

                    /* css-Klasse für Animation entfernen*/
                    $carusselSlider.css('transition', `unset`);
                    ///*left auf 0 setzen*/
                    $carusselSlider.css('left', '0');

                    /* 1. Element hinten anfügen */
                    $carusselSlider.append($($sliderItems[0]));

                }, animationInSeconds * 1000);

            }, intervalInSeconds * 1000);
        }
    }
}